<template>
        <div class="bindRoleWrap" v-if="show">
            <div>
                <img @click="close" src="../assets/xx.png" alt="">
                <p>活动大区：盘古大陆</p>
                <p>活动服务器：渡劫封仙</p>
                <span>请在下方选择绑定游戏角色</span>
                <select v-model="listQuery.roleName"  name="" id="">
                    <option v-for="(item,index) in roleList" :value="item.roleName" :key="index">{{item.roleName}}</option>
                </select>
                        <div>
                                <button @click="BindRoleFn">确定</button>
                                <button @click="close">取消</button>
                        </div>
            </div>
    
        </div>
</template>
<script>
import { GetRoleList , BindRole} from '@/untils/authority'
export default {
    data(){
        return {
            show:true,
            roleList:[],
            listQuery:{
                roleName:'',
                activityId:'2',
            }
        }
    },
    mounted(){
        this.GetRoleListFn()
    },
    methods:{
        close(){
             this.$emit('closeBindRole',{})
        },
        // 角色列表
        GetRoleListFn(){
            GetRoleList().then(response => {
                if(response.result == 1){
                    this.roleList = response.data
                }else{
                    alert(response.message)
                }
            })
        },
        //绑定活动角色
        BindRoleFn(){
            console.log(this.listQuery)
            BindRole(this.listQuery).then(response => {
                if(response.result == 1){
                    this.$emit('closeBindRole',this.listQuery)
                }else{
                     alert(response.message)
                }
            })
        }
    }
}
</script>
<style lang="less">
.bindRoleWrap{
    width:100%;
    height:100vh;
    background:rgba(0,0,0,.8);
    position: relative;
    z-index: 999;
    // top:0px;
    // left:0px;

    >div{
        width: 527px;
	    height: 581px;
        background:url(../assets/bindRole_bg.png);
        position: absolute;
        top:0px;
        left:0px;
        right:0px;
        bottom:0px;
        padding:0px 76px;
        box-sizing: border-box;
        margin:auto;
        >img{
            position: absolute;
            right:-41px;;
            top:0px;
        }
        img+p{
            padding-top:138px;

        }
        select{
            width: 391px;
            background:rgb(35,35,43);
	height: 38px;
       color: rgba(220, 191, 134, 1);
        }
        p{
            font-size: 18px;
            color: rgba(220, 191, 134, 1);
            padding-top:16px;
         
        }
        span{
            color: rgba(237, 130, 25, 1);
            padding-top:21px;
            display: block;
            font-size: 14px;
        }
        >div{
            text-align: center;
            padding-top:37px;
            button{
                width: 79px;
                height: 27px;
                border-radius: 3px;
                border: solid 1px rgba(220, 191, 134, 1);
                color: rgba(220, 191, 134, 1);
                font-size: 18px;
                background:rgba(34,33,41,.8)
            }
            button+button{
                display: inline-block;
                margin-left:106px;
            }
        }
    }
}
</style>